var _circle, _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 622,
    height: 497,
    viewBox: "0 0 622 497",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 216.486,
    cy: 216.486,
    r: 208.486,
    stroke: "black",
    strokeWidth: 16
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 390.955,
    y: 336.257,
    width: 21.8918,
    height: 51.0809,
    transform: "rotate(-57.463 390.955 336.257)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 405.515,
    y: 380.428,
    width: 87.0517,
    height: 203.121,
    rx: 43.5259,
    transform: "rotate(-55.1369 405.515 380.428)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.702 262.83C179.86 271.622 189.69 277.84 200.702 280.54C225.593 286.987 250.09 275.658 255.42 255.255C260.751 234.83 241.486 212.566 216.606 206.108C191.726 199.65 172.45 177.397 177.781 156.983C183.112 136.569 207.598 125.25 232.489 131.698C243.237 134.281 252.957 140.378 260.269 149.123M217.81 282.346V302.837M217.81 105.811V129.892",
    stroke: "black",
    strokeWidth: 21.8918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.9fafa9a26a41908c2b4409936d395bf1.svg";
export { ForwardRef as ReactComponent };